import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Menu.css';

function Register() {
  const [form, setForm] = useState({ username: '', email: '', password: '', regulamin: false, captcha: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [captcha, setCaptcha] = useState(null);
  const navigate = useNavigate();

  // Generate captcha on component mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    const answer = num1 + num2;
    setCaptcha({ num1, num2, answer });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!form.regulamin) {
      setError('Musisz zatwierdzić regulamin.');
      return;
    }
    if (!captcha || parseInt(form.captcha) !== captcha.answer) {
      setError('Odpowiedź na pytanie CAPTCHA jest niepoprawna.');
      generateCaptcha();
      setForm((prev) => ({ ...prev, captcha: '' }));
      return;
    }
    try {
      const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000';
      const response = await fetch(`${API_BASE}/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: form.username, email: form.email, password: form.password, regulamin: form.regulamin })
      });
      if (response.ok) {
        await response.json();
        setSuccess(`Registration successful! Redirecting to login...`);
        setTimeout(() => {
          navigate('/login');
        }, 1500);
        setForm({ username: '', password: '', email: '', regulamin: false });
      } else {
        setError('Registration failed.');
      }
    } catch {
      setError('Network error.');
    }
  };

  return (
    <div className="auth-page">
      <h2 style={{ textAlign: 'center' }}>Register</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '20px' }}>
          <label>Username</label>
          <input
            type="text"
            name="username"
            value={form.username}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '8px', marginTop: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '8px', marginTop: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label>Password</label>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '8px', marginTop: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            name="regulamin"
            checked={form.regulamin}
            onChange={handleChange}
            style={{ marginRight: '10px' }}
          />
          <label>I approve the regulamin</label>
        </div>
        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#fff', borderRadius: '4px', border: '1px solid #ddd' }}>
          <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
            Security Verification: What is {captcha?.num1} + {captcha?.num2}?
          </label>
          <input
            type="number"
            name="captcha"
            value={form.captcha}
            onChange={handleChange}
            placeholder="Enter answer"
            style={{ width: '100%', padding: '8px', marginTop: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>
        <button type="submit" style={{ width: '100%', background: '#111', color: '#fff', padding: '10px', border: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '1em', cursor: 'pointer' }}>
          Register
        </button>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
      </form>
    </div>
  );
}

export default Register;
